import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  identityList: []
}

const identitySlice = createSlice({
  name: 'identity',
  initialState,
  reducers: {
    saveIdentity: (state, action) => {
      state.identityList.push(action.payload)
    },
    deleteIdentity: (state, action) => {
      state.identityList = [];
    },
  }
});

export const {
  saveIdentity,
  deleteIdentity
} = identitySlice.actions

export const selectIdentityList = state => state.identity.identityList

export default identitySlice.reducer